import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 14 14"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M3 1.5A1.5 1.5 0 0 1 4.5 0h8A1.5 1.5 0 0 1 14 1.5v2A1.5 1.5 0 0 1 12.5 5h-8A1.5 1.5 0 0 1 3 3.5v-.25h-.75A.75.75 0 0 0 1.5 4v1c0 .69.56 1.25 1.25 1.25H6A2.75 2.75 0 0 1 8.75 9v.02A1.5 1.5 0 0 1 10 10.5v3a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-3a1.5 1.5 0 0 1 1.25-1.48V9c0-.69-.56-1.25-1.25-1.25H2.75A2.75 2.75 0 0 1 0 5V4a2.25 2.25 0 0 1 2.25-2.25H3z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const interfaceEditToolPaintRoller = { render };
export {
  interfaceEditToolPaintRoller as default,
  render
};
//# sourceMappingURL=interface-edit-tool-paint-roller.svg.js.map
